export async function checkAndRequestMicPermission() {
  try {
    // Check permission status for microphone
    const status = await navigator.permissions.query({ name: "microphone" });

    console.log("Microphone permission status:", status.state);

    if (status.state === "granted") {
      console.log("Mic permission already granted.");
      return true;
    } else if (status.state === "prompt") {
      // Ask user for permission by requesting media access
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        console.log("Mic permission granted after prompt.");
        return true;
      } catch (err) {
        alert(
          "You have denied the request to use your microphone. You will not be able to answer calls.",
        );
        return false;
      }
    } else if (status.state === "denied") {
      console.warn(
        "Mic permission denied previously. Please enable it from browser settings.",
      );
      alert(
        "You have denied the request to use your microphone. You will not be able to answer calls. Please enable it from browser settings, or contact support for assistance.",
      );
      // You can optionally prompt user to manually enable mic permissions.
      return false;
    }
  } catch (err) {
    // Permissions API not supported, fallback to just requesting mic
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      console.log("Mic permission granted.");
      return true;
    } catch (err) {
      console.warn("Mic permission denied or error:", err);
      return false;
    }
  }
}
